import React from 'react';
import './ourServices.scss';

const InteligenciaArtificialService = () => {
  return (
    <div className="our-services">
      <div className="our-services__container">
        <div className="our-services__content">
          <h2 className="our-services__title">
            Análisis Predictivo del Público
          </h2>
          <div className="our-services__title-line" />
          <p className="our-services__text">
            Predecimos la respuesta emocional y conductual del público ante cada
            elemento de tu producción audiovisual.
          </p>
          <p className="our-services__text">
            Utilizamos modelos avanzados de IA para anticipar cómo reaccionará
            la audiencia ante tramas, personajes, diálogos y decisiones de
            montaje. La integración de Business Intelligence permite realizar un
            seguimiento en tiempo real de las reacciones del público y ajustar
            las estrategias de marketing y distribución en consecuencia.
          </p>
          <p className="our-services__text">
            Nuestro enfoque convierte datos emocionales en ventaja competitiva,
            permitiendo a las productoras tomar decisiones estratégicas basadas
            en evidencia científica antes, durante y después de la producción.
          </p>
        </div>
        <div className="our-services__solutions">
          <h3 className="our-services__subtitle">
            Entre nuestras soluciones se incluyen:
          </h3>
          <ul className="our-services__list">
            <li className="our-services__item">
              <p className="our-services__item-title">
                Modelos predictivos de respuesta emocional
              </p>
              <p className="our-services__item-desc">
                Analizamos tramas, personajes y diálogos para predecir el
                impacto emocional en diferentes perfiles de audiencia.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Análisis de arousal emocional
              </p>
              <p className="our-services__item-desc">
                Medimos y optimizamos los niveles de activación emocional a lo
                largo de la narrativa para maximizar el engagement del
                espectador.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Segmentación de audiencias
              </p>
              <p className="our-services__item-desc">
                Identificamos perfiles de espectadores y adaptamos la estrategia
                narrativa y de distribución a cada segmento.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Optimización de campañas de marketing
              </p>
              <p className="our-services__item-desc">
                Ajustamos las campañas de distribución y promoción basándonos en
                datos reales de respuesta del público.
              </p>
            </li>
            <li className="our-services__item">
              <p className="our-services__item-title">
                Informes de rentabilidad predictiva
              </p>
              <p className="our-services__item-desc">
                Mejoramos la rentabilidad de los proyectos mediante ajustes
                estratégicos basados en predicciones de audiencia.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InteligenciaArtificialService;
